import { Redirect } from '#app/components/Redirect/index.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useSelectedUserType } from '#app/hooks/useSelectedUserType.js';
import { getRoute } from '@contra/routes';

export const Page = () => {
  const currentUser = useCurrentUser();
  const { isClient } = useSelectedUserType();

  if (!currentUser) {
    return (
      <Redirect
        method="replace"
        to={getRoute('/')}
      />
    );
  }

  if (isClient) {
    return (
      <Redirect
        method="replace"
        to={getRoute('/client/home')}
      />
    );
  } else {
    return (
      <Redirect
        method="replace"
        to={getRoute('/independent/home')}
      />
    );
  }
};
